import React from "react";
import WebViewWrapper from "../../components/WebViewWrapper";
import { Meta, StoryObj } from "@storybook/react";
import Button from "../../components/Button";
import VStack from "../../ui_atoms/VStack";

const ComponentStory = ({ url, enableBack }: { url: string; enableBack: boolean }) => {
    const [visible, setVisible] = React.useState(true);
    return (
        <VStack h={1} alignment="center">
            <Button label="Open web view" onPress={() => setVisible(!visible)} />
            <WebViewWrapper
                url={visible ? url : null}
                enableBack={enableBack}
                onUrlChanged={(x) => {
                    if (x === "__cancel__") {
                        setVisible(false);
                    }
                }}
            />
        </VStack>
    );
};

const meta = {
    title: "Components/WebViewWrapper",
    component: ComponentStory,
    args: {},
    argTypes: {
        enableBack: { control: "boolean" },
    },
} satisfies Meta<typeof ComponentStory>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {
        enableBack: true,
        url: "https://www.liftapp.ch",
    },
};
